<template>
  <div>
    <v-row class="page-title-container">
      <v-col class="col-12">
        <h2 class="page-title">{{ lang.menuLinks.addMemories }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div>
          <v-stepper v-model="e1" class="stepper-custom">
            <v-stepper-header>
              <v-stepper-step :step="1">{{
                lang.addMemories.pick
              }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :step="2">{{
                lang.addMemories.personalInfo
              }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :step="3">{{
                lang.addMemories.favorites
              }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :step="4">{{
                lang.addMemories.graveInfo
              }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :step="5">{{
                lang.addMemories.package
              }}</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content class="step-1" :step="1">
                <v-row class="step-1 no-gutters">
                  <v-col class="col-12 offset-md-3 col-md-6 person-type-pick">
                    <v-card class="mb-12" elevation="0">
                      <v-card-text class="px-0">
                        <h1>
                          {{ lang.addMemories.w1 }}
                        </h1>
                        <h3>{{ lang.addMemories.w2 }}</h3>
                        <h2>
                          {{ lang.addMemories.w4 }}
                        </h2>
                        <div class="d-flex justify-center mt-12 py-6">
                          <!-- todo change to 1 -->
                          <v-btn
                            outlined
                            :class="{ human: hovered == 'human' }"
                            @mouseover="hovered = 'human'"
                            class="pick-buttons rounded-xl"
                            @click="nextStep(1, 'human')"
                            >{{ lang.actions.humanBeing }}</v-btn
                          >
                          <v-btn
                            outlined
                            :class="{ pets: hovered == 'pets' }"
                            @mouseover="hovered = 'pets'"
                            class="pick-buttons rounded-xl"
                            @click="nextStep(1, 'pet')"
                            >{{ lang.actions.pet }}</v-btn
                          >
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-stepper-content>

              <v-stepper-content :step="2">
                <v-alert
                  class="py-2 mt-0 caption"
                  border="left"
                  colored-border
                  color="border-primary"
                  elevation="1"
                  >{{ lang.addMemories.later }}</v-alert
                >
                <v-card class="mb-12" elevation="0">
                  <v-card-text class="px-0">
                    <v-form ref="personalInfoForm">
                      <v-row>
                        <v-col
                          v-if="pick === 'human'"
                          class="col-12 col-sm-6 col-md-4"
                        >
                          <div class="input-group">
                            <label>{{ lang.fields.name }} *</label>
                            <input
                              type="text"
                              v-model="personManage.FirstName"
                            />
                          </div>
                        </v-col>
                        <v-col v-else class="col-12 col-sm-6 col-md-4">
                          <div class="input-group">
                            <label>{{ lang.fields.name }} *</label>
                            <input type="text" v-model="personManage.Name" />
                          </div>
                        </v-col>
                        <v-col
                          class="col-12 col-sm-6 col-md-4"
                          v-if="pick === 'human'"
                        >
                          <div class="input-group">
                            <label>{{ lang.fields.surname }} *</label>
                            <input
                              type="text"
                              v-model="personManage.LastName"
                            />
                          </div>
                        </v-col>
                        <v-col
                          class="col-12 col-sm-6 col-md-4"
                          v-if="pick === 'pet'"
                        >
                          <div class="input-group">
                            <label>{{ lang.fields.breed }}</label>
                            <input type="text" v-model="personManage.Breed" />
                          </div>
                        </v-col>
                        <v-col
                          class="col-12 col-sm-6 col-md-4"
                          v-if="pick === 'pet'"
                        >
                          <div class="input-group">
                            <label>{{ lang.fields.species }}</label>
                            <input type="text" v-model="personManage.Species" />
                          </div>
                        </v-col>
                        <v-col
                          class="col-12 col-sm-6 col-md-4"
                          v-if="pick === 'pet'"
                        >
                          <div class="input-group">
                            <label>{{ lang.fields.passport }}</label>
                            <input
                              type="text"
                              v-model="personManage.PassportId"
                            />
                          </div>
                        </v-col>
                        <v-col
                          class="col-12 col-sm-6 col-md-4"
                          v-if="pick === 'pet'"
                        >
                          <div class="input-group">
                            <label>{{ lang.fields.id }}</label>
                            <input type="text" v-model="personManage.ChipId" />
                          </div>
                        </v-col>
                        <v-col class="col-12 col-sm-6 col-md-4 my-0 py-0">
                          <v-radio-group
                            hide-details
                            v-model="personManage.Gender"
                            row
                            class="pt-6"
                          >
                            <v-radio
                              :label="lang.fields.other"
                              value="Other"
                              :ripple="false"
                            ></v-radio>
                            <v-radio
                              :label="lang.fields.male"
                              value="Male"
                              :ripple="false"
                            ></v-radio>
                            <v-radio
                              :label="lang.fields.female"
                              value="Female"
                              :ripple="false"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col class="col-12 col-sm-6 col-md-4 custom-input">
                          <div class="input-group">
                            <label>{{ lang.fields.birthDate + " *" }}</label>
                            <v-dialog
                              ref="dialogBirth"
                              v-model="modalBirth"
                              :return-value.sync="personManage.DateOfBirth"
                              persistent
                              width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="personManage.DateOfBirth"
                                  prepend-inner-icon="mdi-calendar"
                                  readonly
                                  hide-details
                                  outlined
                                  v-bind="attrs"
                                  dense
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="personManage.DateOfBirth"
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="modalBirth = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="
                                    $refs.dialogBirth.save(personManage.DateOfBirth)
                                  "
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </div>
                        </v-col>
                        <v-col class="col-12 col-sm-6 col-md-4 custom-input">
                          <div class="input-group">
                            <label>{{ lang.fields.deathDate + " *" }}</label>
                            <v-dialog
                              ref="dialogDeath"
                              v-model="modalDeath"
                              :return-value.sync="personManage.DateOfDeath"
                              persistent
                              width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="personManage.DateOfDeath"
                                  prepend-inner-icon="mdi-calendar"
                                  readonly
                                  hide-details
                                  outlined
                                  v-bind="attrs"
                                  dense
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="personManage.DateOfDeath"
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="modalDeath = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="
                                    $refs.dialogDeath.save(personManage.DateOfDeath)
                                  "
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </div>
                        </v-col>
                        <v-col class="col-12 col-sm-6 col-md-4 custom-input">
                          <div class="input-group">
                            <label>{{ lang.fields.country }}</label>
                            <v-autocomplete
                              :items="countriesDropdown"
                              prepend-inner-icon="mdi-earth"
                              outlined
                              dense
                              hide-details
                              v-model="personManage.Country"
                            ></v-autocomplete>
                          </div>
                        </v-col>
                        <v-col class="col-12 col-sm-6 col-md-4">
                          <div class="input-group">
                            <label>{{ lang.fields.city }}</label>
                            <input type="text" v-model="personManage.City" />
                          </div>
                        </v-col>

                        <v-col class="col-12 col-sm-6 col-md-4">
                          <div class="input-group">
                            <label>{{ lang.fields.nickname }}</label>
                            <input
                              type="text"
                              v-model="personManage.Nickname"
                            />
                          </div>
                        </v-col>
                        <v-col
                          class="col-12 col-sm-6 col-md-4"
                          v-if="pick === 'human'"
                        >
                          <div class="input-group">
                            <label>{{ lang.fields.occupation }}</label>
                            <input
                              type="text"
                              v-model="personManage.Occupation"
                            />
                          </div>
                        </v-col>
                        <v-col
                          class="col-12 col-sm-6 col-md-4"
                          v-if="pick === 'human'"
                        >
                          <div class="input-group">
                            <label>{{ lang.fields.zodiacSign }}</label>
                            <input
                              type="text"
                              v-model="personManage.ZodiacSign"
                            />
                          </div>
                        </v-col>
                        <v-col
                          class="col-12 col-sm-6 col-md-4"
                          v-if="pick === 'human'"
                        >
                          <div class="input-group">
                            <label>{{ lang.fields.eyeColor }}</label>
                            <input
                              type="text"
                              v-model="personManage.EyeColor"
                            />
                          </div>
                        </v-col>
                        <v-col class="col-12 col-sm-3 col-md-2">
                          <div class="input-group">
                            <label>{{ lang.fields.height }}</label>
                            <input type="text" v-model="personManage.Height" />
                          </div>
                        </v-col>
                        <v-col class="col-12 col-sm-3 col-md-2">
                          <div class="input-group">
                            <label>{{ lang.fields.weight }}</label>
                            <input type="text" v-model="personManage.Weight" />
                          </div>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
                <div class="d-flex justify-space-between px-2 pb-2">
                  <v-btn
                    color="primary"
                    elevation="0"
                    class="mr-2"
                    text
                    @click="backStep(1)"
                  >
                    {{ lang.actions.back }}
                  </v-btn>

                  <v-btn class="btn-bg" @click="nextStep(2)" elevation="0">
                    {{ lang.actions.continue }}
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content :step="3">
                <v-alert
                  class="py-2 mt-0 caption"
                  border="left"
                  colored-border
                  color="border-primary"
                  elevation="1"
                  >{{ lang.addMemories.later }}</v-alert
                >
                <v-card class="mb-12" elevation="0">
                  <v-card-text class="px-0">
                    <v-row>
                      <v-col v-if="pick === 'human'" class="col-12 mb-n2 mt-0"
                        ><span class="title primary--text">{{
                          lang.addMemories.food
                        }}</span></v-col
                      >
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.breakfast }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteBreakfast"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.lunch }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteLunch"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.dinner }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteDinner"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.snacks }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteSnacks"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.food }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteFood"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.meat }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteMeat"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.pizza }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoritePizza"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.pasta }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoritePasta"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.vegetable }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteVegetable"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.fruit }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteFruit"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.desert }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteDesert"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.cake }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteCake"
                          />
                        </div>
                      </v-col>

                      <v-col v-if="pick === 'human'" class="col-12 mb-n2 mt-8"
                        ><span class="title primary--text">{{
                          lang.addMemories.drinks
                        }}</span></v-col
                      >
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.drink }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteDrink"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.wine }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteWine"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.beer }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteBeer"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.tea }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteTea"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.coffee }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteCoffee"
                          />
                        </div>
                      </v-col>

                      <v-col v-if="pick === 'human'" class="col-12 mb-n2 mt-8"
                        ><span class="title primary--text">{{
                          lang.addMemories.movies
                        }}</span></v-col
                      >
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.movie }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteMovie"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.movieGenre }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteMovieGenre"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.actor }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteActor"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.actress }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteActress"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.tvShow }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteTvShow"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.cartoon }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteCartoon"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.marvelMovie }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteMarvelMovie"
                          />
                        </div>
                      </v-col>

                      <v-col v-if="pick === 'human'" class="col-12 mb-n2 mt-8"
                        ><span class="title primary--text">{{
                          lang.addMemories.musics
                        }}</span></v-col
                      >
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.band }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteBand"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.song }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteSong"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.musicGenre }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteMusicGenre"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.maleSigner }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteMaleSigner"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.femaleSigner }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteFemaleSigner"
                          />
                        </div>
                      </v-col>

                      <v-col v-if="pick === 'human'" class="col-12 mb-n2 mt-8"
                        ><span class="title primary--text">{{
                          lang.addMemories.books
                        }}</span></v-col
                      >
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.book }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteBook"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.maleWriter }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteMaleWriter"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.femaleWriter }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteFemaleWriter"
                          />
                        </div>
                      </v-col>

                      <v-col v-if="pick === 'human'" class="col-12 mb-n2 mt-8"
                        ><span class="title primary--text">{{
                          lang.addMemories.sports
                        }}</span></v-col
                      >
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.sport }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteSport"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.sportPlayer }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteSportPlayer"
                          />
                        </div>
                      </v-col>

                      <v-col v-if="pick === 'human'" class="col-12 mb-n2 mt-8"
                        ><span class="title primary--text">{{
                          lang.addMemories.lifestyle
                        }}</span></v-col
                      >
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.dance }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteDance"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.car }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteCar"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.game }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteGame"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.hobby }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteHobby"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.color }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteColor"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.flower }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteFlower"
                          />
                        </div>
                      </v-col>

                      <v-col v-if="pick === 'human'" class="col-12 mb-n2 mt-8"
                        ><span class="title primary--text">{{
                          lang.addMemories.travel
                        }}</span></v-col
                      >
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.travelPlace }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteTravelPlace"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.museum }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteMuseum"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.waterfall }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteWaterfall"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.beach }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteBeach"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.lake }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteLake"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.sea }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteSea"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.ocean }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteOcean"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.island }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteIsland"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.mountain }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteMountain"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.river }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteRiver"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.city }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteCity"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'human'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.country }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteCountry"
                          />
                        </div>
                      </v-col>

                      <!-- pets -->
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'pet'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.food }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteFood"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'pet'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.desert }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteDesert"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'pet'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.drink }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteDrink"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="col-12 col-sm-6 col-md-3"
                        v-if="pick === 'pet'"
                      >
                        <div class="input-group">
                          <label>{{ lang.fields.toy }}</label>
                          <input
                            type="text"
                            v-model="personManage.FavoriteToy"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <div class="d-flex justify-space-between px-2 pb-2">
                  <v-btn
                    color="primary"
                    elevation="0"
                    class="mr-2"
                    text
                    @click="backStep(2)"
                  >
                    {{ lang.actions.back }}
                  </v-btn>
                  <v-btn class="btn-bg" elevation="0" @click="nextStep(3)">
                    {{ lang.actions.continue }}
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content :step="4">
                <v-alert
                  class="py-2 mt-0 caption"
                  border="left"
                  colored-border
                  color="border-primary"
                  elevation="1"
                  >{{ lang.addMemories.later }}</v-alert
                >
                <v-card class="mb-12" elevation="0">
                  <v-card-text class="px-0">
                    <v-row>
                      <v-col class="col-12 d-flex align-center">
                        <v-switch
                          hide-details
                          inset
                          class="ml-1 mr-3"
                          :ripple="false"
                          v-model="useCurrentLocation"
                          :label="lang.fields.useCurrentLocation"
                        ></v-switch>
                      </v-col>
                      <v-col class="col-12 col-md-6">
                        <div class="input-group">
                          <label>{{ lang.fields.latitude }}</label>
                          <input
                            type="text"
                            v-model="personManage.GraveLocationLat"
                          />
                        </div>
                      </v-col>
                      <v-col class="col-12 col-md-6">
                        <div class="input-group">
                          <label>{{ lang.fields.longitude }}</label>
                          <input
                            type="text"
                            v-model="personManage.GraveLocationLng"
                          />
                        </div>
                      </v-col>
                      <v-col class="col-12 col-md-6">
                        <div class="input-group">
                          <label>{{ lang.fields.country }}</label>
                          <input
                            type="text"
                            v-model="personManage.GraveLocationCountry"
                          />
                        </div>
                      </v-col>
                      <v-col class="col-12 col-md-6">
                        <div class="input-group">
                          <label>{{ lang.fields.city }}</label>
                          <input
                            type="text"
                            v-model="personManage.GraveLocationCity"
                          />
                        </div>
                      </v-col>
                      <v-col class="col-12 col-md-12">
                        <div class="input-group">
                          <label>{{ lang.fields.additionalDescription }}</label>
                          <textarea
                            v-model="personManage.GraveLocationDescription"
                            rows="4"
                          ></textarea>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                <div class="d-flex justify-space-between px-2 pb-2">
                  <v-btn
                    color="primary"
                    elevation="0"
                    class="mr-2"
                    text
                    @click="backStep(3)"
                  >
                    {{ lang.actions.back }}
                  </v-btn>
                  <v-btn class="btn-bg" elevation="0" @click="nextStep(4)">
                    {{ lang.actions.continue }}
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content :step="5">
                <v-alert
                  class="py-2 mt-0 mb-6"
                  border="left"
                  colored-border
                  color="border-primary"
                  elevation="1"
                  >{{ lang.addMemories.whyFree }}</v-alert
                >
                <div class="package-container">
                  <div
                    @click="selectPackage(p.name)"
                    :class="{
                      'selected-package': selectedPackage === p.name,
                      'greyed-out':
                        selectedPackage !== p.name && selectedPackage !== '',
                    }"
                    v-for="(p, index) in packages"
                    :key="p.name + index"
                  >
                    <div class="free-always" v-if="p.name == 'Premium'">
                      <p>
                        <strong>{{ lang.addMemories.freeAlways }}</strong>
                      </p>
                    </div>
                    <div class="package-switch" v-else-if="p.name != 'Free'">
                      <span class="switch-label">Yearly</span>
                      <v-switch
                        :disabled="p.name != selectedPackage"
                        v-model="p.type"
                        :value="'monthly'"
                        inset
                        class="mr-0"
                        color="white"
                        :ripple="false"
                        hide-details
                      ></v-switch>
                      <span class="switch-label">Monthly</span>
                    </div>

                    <div class="d-flex align-center">
                      <p class="subtitle-1 font-weight-bold mt-0 mb-1">
                        {{ p.name }}
                      </p>
                      <v-spacer></v-spacer>
                      <p class="title mt-0 cross-over">€{{ p.priceMonth }}</p>
                      <span class="subtitle-2 pt-2 grey--text"
                        >/{{ lang.addMemories.perMonth }}</span
                      >
                    </div>
                    <v-btn
                      width="100%"
                      elevation="0"
                      color="blue lighten-1"
                      outlined
                      large
                      rounded
                      class="mt-1 mb-3 show-mobile"
                      @click="nextStep(5)"
                      >{{
                        p.name == "Premium"
                          ? lang.actions.createFreeProfile
                          : lang.actions.createProfile
                      }}</v-btn
                    >
                    <v-divider class="mb-2"></v-divider>
                    <p class="subtitle-2">
                      <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >{{ p.images }} images
                    </p>
                    <p class="subtitle-2">
                      <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >{{ p.videos }} videos
                    </p>
                    <p class="subtitle-2">
                      <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >{{ p.documents }} documents
                    </p>
                    <p class="subtitle-2">
                      <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >{{ p.lastGreetings }} last greetings
                    </p>
                    <p class="subtitle-2">
                      <v-icon class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >{{ p.biography }} timelines <br /><span
                        class="caption green--text pl-5"
                        >{{ p.biographyDescription }}</span
                      >
                    </p>
                    <p class="subtitle-2">
                      <v-icon
                        v-if="p.likes === 'Yes'"
                        class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon
                        v-else
                        class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                        >mdi-close-circle-outline</v-icon
                      >Likes
                    </p>
                    <p class="subtitle-2">
                      <v-icon
                        v-if="p.imageAndVideoInfo === 'Yes'"
                        class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon
                        v-else
                        class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                        >mdi-close-circle-outline</v-icon
                      >Image and video info
                    </p>
                    <p class="subtitle-2">
                      <v-icon
                        v-if="p.bookmarks === 'Yes'"
                        class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon
                        v-else
                        class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                        >mdi-close-circle-outline</v-icon
                      >Bookmarks
                    </p>
                    <p class="subtitle-2">
                      <v-icon
                        v-if="p.comments === 'Yes'"
                        class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon
                        v-else
                        class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                        >mdi-close-circle-outline</v-icon
                      >Video and image comments
                    </p>
                    <p class="subtitle-2">
                      <v-icon
                        v-if="p.suggestPhoto === 'Yes'"
                        class="subtitle-1 mb-0 mr-1 blue--text lighten-4"
                        >mdi-check-circle</v-icon
                      >
                      <v-icon
                        v-else
                        class="subtitle-1 mb-0 mr-1 red--text lighten-4"
                        >mdi-close-circle-outline</v-icon
                      >Followers can suggest photos
                    </p>
                    <v-divider class="mt-2"></v-divider>
                    <div class="d-flex align-center">
                      <p
                        class="title mt-2 mb-0"
                        :class="{
                          'cross-over': p.type == 'monthly' && p.name != 'Free',
                          'blue--text lighten-4':
                            (p.name == 'Free' && p.name == selectedPackage) ||
                            (p.type != 'monthly' && p.name == selectedPackage),
                        }"
                      >
                        €{{ p.priceYear }}
                      </p>
                      <span
                        class="subtitle-2 pt-2"
                        :class="{
                          'blue--text lighten-4':
                            (p.name == 'Free' && p.name == selectedPackage) ||
                            (p.type != 'monthly' && p.name == selectedPackage),
                          'grey--text':
                            p.name != 'Free' &&
                            p.type &&
                            p.name == selectedPackage,
                        }"
                        >/{{ lang.addMemories.perYear }}</span
                      >
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-space-between px-2 pb-0">
                  <v-btn
                    color="primary"
                    elevation="0"
                    class="mr-2"
                    text
                    @click="backStep(4)"
                  >
                    {{ lang.actions.back }}
                  </v-btn>
                  <v-btn
                    @click="nextStep(5)"
                    elevation="0"
                    color="blue lighten-1 white--text"
                  >
                    {{ lang.actions.create }}
                  </v-btn>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import packagesList from "../script/packages";
import helpers from "../plugins/helpers";
export default {
  name: "AddMemories",
  data() {
    return {
      modalBirth: false,
      modalDeath: false,
      useCurrentLocation: false,
      selected: "",
      hovered: "",
      pick: null,
      dateOfBirthMenu: false,
      dateOfDeathMenu: false,
      activePickerBirth: null,
      activePickerDeath: null,
      e1: 1,
      steps: 5,
      selectedPackage: "Premium",
      packages: packagesList.packages,
    };
  },
  computed: {
    ...mapGetters(["rules"]),
    ...mapGetters("user", ["currentUser"]),
    ...mapGetters("person", ["personManage"]),
    // ...mapGetters("person", ["personManage", "packages"]),
    countriesDropdown() {
      return helpers.countries().map((el) => el.text);
    },
    tillNextYear() {
      return moment().add(1, "year").format("MMMM Do YYYY.");
    },
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  mounted() {
    document.title = "Good Casper - Add Memories";
    // this.$store.dispatch("person/getPackages");
  },
  watch: {
    useCurrentLocation(val) {
      if (val) {
        this.getCurrentLocation();
      } else {
        this.personManage.GraveLocationLat = "";
        this.personManage.GraveLocationLng = "";
      }
    },
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
    dateOfBirthMenu(val) {
      val &&
        setTimeout(() => {
          this.activePickerBirth = "YEAR";
        }, 500);
    },
    dateOfDeathMenu(val) {
      val &&
        setTimeout(() => {
          this.activePickerDeath = "YEAR";
        }, 500);
    },
  },
  methods: {
    getCurrentLocation() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.personManage.GraveLocationLat =
              position.coords.latitude.toFixed(6);
            this.personManage.GraveLocationLng =
              position.coords.longitude.toFixed(6);
          },
          (err) => {
            console.error("Error:", err.message);
          }
        );
      }
    },
    selectPackage(name) {
      this.selectedPackage = "Premium"; // todo name;
    },
    createPerson() {
      this.personManage.userId = this.currentUser.id;
      this.personManage.isPet = this.pick === "pet";
      this.personManage.packageName = "Free always - Premium"; // todo - this.selectedPackage;
      var aYearFromNow = new Date();
      aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
      this.personManage.packageDueDate = aYearFromNow;
      var toSend = { ...this.personManage };
      if (this.personManage.isPet) {
        toSend.Favorites = [
          { Type: "FavoriteFood", Value: toSend.FavoriteFood },
          { Type: "FavoriteDesert", Value: toSend.FavoriteDesert },
          { Type: "FavoriteDrink", Value: toSend.FavoriteDrink },
          { Type: "FavoriteToy", Value: toSend.FavoriteToy },
        ];
        this.$store.dispatch("person/addPet", toSend);
      } else {
        toSend.Favorites = [
          { Type: "FavoriteColor", Value: toSend.FavoriteColor },
          { Type: "FavoriteFood", Value: toSend.FavoriteFood },
          { Type: "FavoriteDesert", Value: toSend.FavoriteDesert },
          { Type: "FavoriteDrink", Value: toSend.FavoriteDrink },
          { Type: "FavoriteToy", Value: toSend.FavoriteToy },
          { Type: "FavoriteBreakfast", Value: toSend.FavoriteBreakfast },
          { Type: "FavoriteLunch", Value: toSend.FavoriteLunch },
          { Type: "FavoriteDinner", Value: toSend.FavoriteDinner },
          { Type: "FavoriteSnacks", Value: toSend.FavoriteSnacks },
          { Type: "FavoritePizza", Value: toSend.FavoritePizza },
          { Type: "FavoritePasta", Value: toSend.FavoritePasta },
          { Type: "FavoriteVegetable", Value: toSend.FavoriteVegetable },
          { Type: "FavoriteFruit", Value: toSend.FavoriteFruit },
          { Type: "FavoriteMeat", Value: toSend.FavoriteMeat },
          { Type: "FavoriteCake", Value: toSend.FavoriteCake },
          { Type: "FavoriteCoffee", Value: toSend.FavoriteCoffee },
          { Type: "FavoriteWine", Value: toSend.FavoriteWine },
          { Type: "FavoriteBeer", Value: toSend.FavoriteBeer },
          { Type: "FavoriteTea", Value: toSend.FavoriteTea },
          { Type: "FavoriteTravelPlace", Value: toSend.FavoriteTravelPlace },
          { Type: "FavoriteMuseum", Value: toSend.FavoriteMuseum },
          { Type: "FavoriteWaterfall", Value: toSend.FavoriteWaterfall },
          { Type: "FavoriteBeach", Value: toSend.FavoriteBeach },
          { Type: "FavoriteLake", Value: toSend.FavoriteLake },
          { Type: "FavoriteSea", Value: toSend.FavoriteSea },
          { Type: "FavoriteOcean", Value: toSend.FavoriteOcean },
          { Type: "FavoriteIsland", Value: toSend.FavoriteIsland },
          { Type: "FavoriteMountain", Value: toSend.FavoriteMountain },
          { Type: "FavoriteRiver", Value: toSend.FavoriteRiver },
          { Type: "FavoriteCity", Value: toSend.FavoriteCity },
          { Type: "FavoriteCountry", Value: toSend.FavoriteCountry },
          { Type: "FavoriteMovie", Value: toSend.FavoriteMovie },
          { Type: "FavoriteMovieGenre", Value: toSend.FavoriteMovieGenre },
          { Type: "FavoriteActor", Value: toSend.FavoriteActor },
          { Type: "FavoriteActress", Value: toSend.FavoriteActress },
          { Type: "FavoriteTvShow", Value: toSend.FavoriteTvShow },
          { Type: "FavoriteCartoon", Value: toSend.FavoriteCartoon },
          { Type: "FavoriteMarvelMovie", Value: toSend.FavoriteMarvelMovie },
          { Type: "FavoriteBand", Value: toSend.FavoriteBand },
          { Type: "FavoriteSong", Value: toSend.FavoriteSong },
          { Type: "FavoriteMusicGenre", Value: toSend.FavoriteMusicGenre },
          { Type: "FavoriteMaleSigner", Value: toSend.FavoriteMaleSigner },
          { Type: "FavoriteFemaleSigner", Value: toSend.FavoriteFemaleSigner },
          { Type: "FavoriteBook", Value: toSend.FavoriteBook },
          { Type: "FavoriteMaleWriter", Value: toSend.FavoriteMaleWriter },
          { Type: "FavoriteFemaleWriter", Value: toSend.FavoriteFemaleWriter },
          { Type: "FavoriteSportPlayer", Value: toSend.FavoriteSportPlayer },
          { Type: "FavoriteSport", Value: toSend.FavoriteSport },
          { Type: "FavoriteDance", Value: toSend.FavoriteDance },
          { Type: "FavoriteCar", Value: toSend.FavoriteCar },
          { Type: "FavoriteGame", Value: toSend.FavoriteGame },
          { Type: "FavoriteHobby", Value: toSend.FavoriteHobby },
          { Type: "FavoriteFlower", Value: toSend.FavoriteFlower },
        ];
        this.$store.dispatch("person/addPerson", toSend);
      }
    },
    backStep(n) {
      this.e1 = n;
    },
    nextStep(n, pick) {
      if (pick) {
        this.pick = pick;
      }
      if (n === 5) {
        this.createPerson();
      } else {
        if (n === 2) {
          const requiredFields = this.pick == 'pet'
            ? ["Name", "DateOfBirth", "DateOfDeath"]
            : ["FirstName", "LastName", "DateOfBirth", "DateOfDeath"];

          for (const field of requiredFields) {
            if (!this.personManage[field]) {
              this.$store.commit("toast", {
                message: this.lang.general.fillAllFields,
                color: "red lighten-2",
              });
              return;
            }
          }

          if (this.$refs.personalInfoForm.validate()) {
            this.e1 = n + 1;
          }
        } else {
          this.e1 = n + 1;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.package-switch {
  position: absolute;
  display: flex;
  align-items: center;
  top: -55px;
  .switch-label {
    margin: 0;
    padding: 0;
    font-weight: 600;
    font-size: 14px;
    color: #ccc;
    margin: 17px 15px 0 0px;
  }
}
.selected-package {
  .switch-label {
    color: #fff;
  }
}
.no-theme {
  @import "../assets/scss/_variables";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-default {
  @import "../assets/scss/_variables";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-black {
  @import "../assets/scss/_variables_black";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-blue-gray {
  @import "../assets/scss/_variables_blue_grey";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-blue {
  @import "../assets/scss/_variables_blue";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-cyan {
  @import "../assets/scss/_variables_cyan";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-dark-red {
  @import "../assets/scss/_variables_dark_red";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-green {
  @import "../assets/scss/_variables_light_green";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-light-green {
  @import "../assets/scss/_variables_green";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-light-brown {
  @import "../assets/scss/_variables_light_brown";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-lime-dark {
  @import "../assets/scss/_variables_lime_dark";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-orange {
  @import "../assets/scss/_variables_orange";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-pink {
  @import "../assets/scss/_variables_pink";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-light-purple {
  @import "../assets/scss/_variables_purple_light";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}

.theme-purple {
  @import "../assets/scss/_variables_purple";
  .pick-buttons {
    border: 2px solid $color-primary;
    color: $color-primary;
    &.pets {
      background-color: $color-primary;
    }
    &.human {
      background-color: $color-primary;
    }
  }
}
.price-amount {
  text-align: right;
  font-size: 56px;
  font-weight: bold;
  span {
    font-size: 30px;
  }
}
.v-stepper__content {
  &.step-1 {
    margin-bottom: 0;
    padding-bottom: 0;
  }
}
.person-type-pick {
  min-height: 400px;
  transition: all 0.3s;
  text-align: center;
  transition: background-color 0.5s linear;
  h1 {
    font-size: 35px;
    margin: 90px 0 20px 0;
    line-height: 40px;
    color: #000 !important;
  }
  h2 {
    font-size: 35px;
    margin: 70px 0 0px 0;
    color: #000 !important;
    line-height: 38px;
  }
  h3 {
    font-size: 28px;
    margin: 20px 0 20px 0;
    color: #000 !important;
  }
  .rounded-xl {
    border-radius: 4px !important;
  }
  .v-card {
    background: transparent;
  }
}
.pick-buttons {
  width: 170px;
  height: 65px !important;
  transition: all 0.3s;
  &.pets {
    color: #fff !important;
    border-top-left-radius: 4px !important;
    border-top-right-radius: 48px !important;
    border-bottom-right-radius: 4px !important;
    border-bottom-left-radius: 48px !important;
  }
  &.human {
    color: #fff !important;
    border-top-left-radius: 48px !important;
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 48px !important;
    border-bottom-left-radius: 4px !important;
  }
  &:nth-child(1) {
    margin-right: 20px;
  }
}
.selected {
  background: #e1ffd2 !important;
}
.stepper-custom {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  .v-stepper__header {
    box-shadow: none !important;
  }
  .v-stepper__items {
    min-height: 70vh;
  }
}

@media only screen and (max-width: 1050px) {
  .v-stepper__content {
    padding: 10px;
    &.step-1 {
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
  .pick-buttons {
    width: 140px;
    transition: all 0.3s;
    border-radius: 24px;
    &:nth-child(1) {
      margin-right: 10px;
    }
  }
  .step-1 {
    text-align: center;
    h1 {
      font-size: 27px;
      margin: 60px 0 10px 0;
      line-height: 40px;
    }
    h2 {
      font-size: 24px;
      margin: 20px 0 40px 0;
      line-height: 30px;
    }
    h3 {
      font-size: 20px;
      margin: 50px 0 0px 0;
    }
  }
}

@media only screen and (max-width: 600px) {
  .step-1 {
    h1 {
      font-size: 24px;
      margin: 20px 0 10px 0;
      line-height: 40px;
    }
    h2 {
      font-size: 18px;
      margin: 10px 0;
      line-height: 30px;
    }
    h3 {
      font-size: 18px;
      margin: 20px 0 0px 0;
    }
  }
  .price-amount {
    text-align: right;
    font-size: 36px;
    font-weight: bold;
    span {
      font-size: 25px;
    }
  }
  .pick-buttons {
    width: 140px;
    height: 45px !important;
  }
}
</style>

<style lang="scss" scoped>
.cross-over {
  text-decoration: line-through;
}
.package-container {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin-bottom: 30px;
  > div {
    cursor: pointer;
    flex: 0 0 calc(20% - 14px);
    min-width: 260px;
    margin: 7px;
    border: 1px solid #ccc;
    border-top: 48px solid #ccc;
    border-radius: 4px;
    padding: 10px;
    margin: 0 0 20px 0;
    box-sizing: border-box;
    width: 100%;
    transition: all 0.3s;
    position: relative;
    .show-mobile {
      display: none !important;
    }
    @media only screen and (max-width: 1050px) {
      flex: 0 0 calc(30% - 14px);
    }
    @media only screen and (max-width: 600px) {
      .show-mobile {
        display: block !important;
      }
      flex: 0 0 calc(100% - 14px);
      &:nth-child(5) {
        order: 1;
      }
      &:nth-child(4) {
        order: 2;
      }
      &:nth-child(3) {
        order: 3;
      }
      &:nth-child(2) {
        order: 4;
      }
      &:nth-child(1) {
        order: 5;
      }
    }
    &.selected-package {
      border: 1px solid #2196f3 !important;
      border-top: 48px solid #2196f3 !important;
      .v-btn {
        background-color: #2196f3 !important;
        color: #fff !important;
      }
    }
    .free-always {
      position: absolute;
      top: -40px;
      p {
        color: #fff !important;
        font-size: 16px;
        strong {
          text-transform: uppercase;
        }
      }
    }
    &.greyed-out {
      opacity: 0.5;
      .v-btn {
        background-color: #ccc;
        color: #fff !important;
      }
    }
  }
  p {
    margin: 5px;
  }
}
</style>